export const UptimeStatusOptions = {
  NoData: -1,
  Disconnected: 0,
  Connected: 1,
} as const;
export type TUptimeStatusKeys = (typeof UptimeStatusOptions)[keyof typeof UptimeStatusOptions];

export const getUptimeStatusConfig = (status: TUptimeStatusKeys | number) => {
  if (status === UptimeStatusOptions.Connected) {
    return {
      color: 'green',
      label: 'Connected',
      borderColor: 'border-emerald-500',
      backgroundColor: 'bg-emerald-500',
      textColor: 'text-emerald-500',
    };
  }

  if (status === UptimeStatusOptions.Disconnected) {
    return {
      color: 'red',
      label: 'Disconnected',
      borderColor: 'border-red-500',
      backgroundColor: 'bg-red-500',
      textColor: 'text-red-500',
    };
  }

  return {
    color: 'gray',
    label: 'No Data',
    borderColor: 'border-gray-500',
    backgroundColor: 'bg-gray-500',
    textColor: 'text-gray-500',
  };
};
